import { Box } from '@mui/material';
import { PALETTE } from '@/styles/constants';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        padding: { xs: '22px 24px', sm: '26px 60px' },
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'center', sm: 'flex-start' },
        gap: { xs: '8px', sm: 0 },
        background: PALETTE.forest,
        fontSize: '11.5px',
        letterSpacing: '0.03em',
        color: 'rgba(243, 236, 220, 0.65)',
        textAlign: { xs: 'center', sm: 'left' },
      }}
    >
      <Box component="span">© {new Date().getFullYear()} Leap Analytics, Inc.</Box>
      <Box component="span">All Rights Reserved</Box>
    </Box>
  );
}
